// extracted by mini-css-extract-plugin
export default {"wrap":"uK-z","heading":"vK-z"};